import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UIBlockingService } from '../core/ui-blocking.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastNotificationService } from '../core/toast-notification.service';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { ResetPasswordRequest } from '../core/reset-password-request';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  providers: [UIBlockingService],
  styleUrls: ["../../assets/css/login.css"],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  constructor(private authService: AuthService
    , private blockUI: UIBlockingService
    , private router: Router
    , private notificationService: ToastNotificationService
    , private fb: FormBuilder
  ) { }

  loginForm: FormGroup = new FormGroup({
    userName: new FormControl('userName', Validators.required),
    password: new FormControl('password', Validators.required)
  });
  resetForm: FormGroup = new FormGroup({
    userName: new FormControl('userName', Validators.required),
  });

  displayState = 0;


  validationTriggered = false;
  isBusy = false;
  resettingPassword = false;
  twoFaOptions = [];
  loginStep = 1;
  loginData = {
    Username: "",
    Password: "",
    Client_id: "icp.ams.webapp",
    Grant_type: "password"
  };
  resetData: ResetPasswordRequest = {
    Username: ""
  }

  loginPhoto: string;
  loginOverlay: number;
  loginColor: string;
  ngOnInit() {
    this.resetLoginForm();
    this.resetResetForm();
    this.blockUI.start();
    this.authService.getLoginInfo()
        .subscribe((response) => {
            this.loginOverlay = response.loginOverlay || 0.4;
            this.loginColor = response.loginColor || '#ffffff';
            this.loginPhoto = response.loginPhoto || 'url(../../assets/images/login/login-bg.jpg)';
        });
    this.blockUI.stop();
  }

  private resetLoginForm(): void {
    this.loginForm.reset();
    this.loginForm.patchValue({
      userName: '',
      password: ''
    });
  }

  private resetResetForm(): void {
    this.resetForm.reset();
    this.resetForm.patchValue({
      userName: ''
    });
  }

  login() {
    if (this.loginForm.invalid) {
      return;
    }
    this.blockUI.start();
    let isBusy = true;
    this.loginData.Username = this.loginForm.get('userName')?.value;
    this.loginData.Password = this.loginForm.get('password')?.value;
    // this.loginData.twoFaCode = this.finalLoginForm.get('secure_code').value;
    this.authService.login(this.loginData)
      .then((response: any) => {

        var roles = response.roles || "";
        this.authService.setToken(response.access_token);
        localStorage.setItem('userName', response.userName);
        localStorage.setItem('userFirstName', response.userFirstName);
        localStorage.setItem('userLastName', response.userLastName);
        localStorage.setItem('userId', response.userId);
        localStorage.setItem('contactId', response.contactId);
        localStorage.setItem('contactType', response.contactType);
        localStorage.setItem('userEmailAddress', this.loginData.Username);
        localStorage.setItem('impersonating', "false");
        localStorage.setItem('membershipLevel', response.membershipLevel);

        this.authService.authentication.isAuthenticated = true;
        this.authService.authentication.userName = this.loginData.Username;

        isBusy = false;
        this.blockUI.stop();

        if (response.contactType == "SuperAdmin") {
          return this.router.navigate(['/admin-portal/chamber/super-admin-management']);
        }
        else if (response.contactType == "BusinessUser") {
            if (response.membershipLevel == 'HealthAlliance')
                return this.router.navigate(['/admin-portal/member/user-management']);
          return this.router.navigate(['/admin-portal/member/dashboard']);
        }
        else {
          return this.router.navigate(['/admin-portal/member/super-admin-management']);
        }
        //this.authService.whoAmI().then(_ => {
        //  this.blockUI.stop();
        //  var roles = localStorage.getItem('roles');

        //  this.notificationService.success("Login successful");
        //  //if (roles.includes('Super Admin'))
        //  //  return this.router.navigate(['/admins']);
        //  //else
        //  //  return this.router.navigate(['/patients']);
        //})
      }).catch((err/*, status*/) => {

        isBusy = false;
        this.blockUI.stop();
        console.log(err);
        this.notificationService.error('Incorrect username/password');
        this.authService.logout();
      });;
  }
  forgotPassword() {
    if (this.resetForm.invalid) {
      return;
    }
    this.blockUI.start();
    let isBusy = true;
    this.resetData.Username = this.resetForm.get('userName')?.value;
    // this.loginData.twoFaCode = this.finalLoginForm.get('secure_code').value;
    this.authService.initiateResetPassword(this.resetData)
      .then(() => {
        this.blockUI.stop();
        this.notificationService.success("If your email exists in our system, an email with instructions to reset your password has been sent.");
          //if (roles.includes('Super Admin'))
          //  return this.router.navigate(['/admins']);
          //else
          //  return this.router.navigate(['/patients']);
      }, err => {
        this.blockUI.stop();

        isBusy = false;

        var msg =  'An error has occurred';
        this.notificationService.error(msg);

      });
  }




}
